import {
  when as BaconWhen,
} from 'baconjs';

import {
  always,
  identity,
  not,
  pipe,
  prop,
} from 'rambda';

import actionDispatcher from '@/engine/actions/action-dispatcher';
import Api from '@/engine/utils/api';

import notificationStore from '@/engine/stores/notification-store';

import adminTemplateItemDataStore from '@/data/templates/admin-template-item-data-store';

const removeAction = actionDispatcher.subscribe('template-item-remove');

const toRemoveUpdate = ({ keyIndex, items }, { itemId }) => {
  if (keyIndex[itemId] === undefined) {
    return null;
  }

  return items[keyIndex[itemId]];
};

const toRemoveItemRequest = ({ id }) => {
  return Api.delete(`/api/admin/template-items/${id}`);
};

const removeItemUpdates = BaconWhen(
  [adminTemplateItemDataStore.updates.toProperty(), removeAction],
  toRemoveUpdate,
)
  .filter(identity);

const removeItemRequestUpdates = removeItemUpdates
  .flatMap(toRemoveItemRequest);

const failedRemoveUpdates = removeItemRequestUpdates
  .errors()
  .mapError(always({ message: 'Failed to remove item', type: 'error' }));

const removeTemplateItemDsUnsubscribe = removeItemUpdates
  .onValue(adminTemplateItemDataStore.remove);

const failedNotificationUnsubscribe = failedRemoveUpdates
  .onValue(notificationStore.publish);

if (process.env.NODE_ENV === 'development') {
  if (module.hot) {
    module.hot.accept();
    module.hot.dispose(() => {
      console.warn('unloading admin-template-item-remove-store');
      removeTemplateItemDsUnsubscribe();
      failedNotificationUnsubscribe();
    });
  }
}
